<template>
    <div class="page bg-gray">
        <backTitleBar></backTitleBar>
        <div class="card">
            <div class="text-center pd-250 fs-28 color-999">请输入核销码</div>
            <input type="number" class="input">
        </div>

        <div class="main-btn click">确定</div>

        <img :src="scan_img" alt="" class="scan-img click" @click="scan">
    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    export default {
        name: "verification",
        components: {backTitleBar},
        data(){
            return{
                scan_img: require("../../assets/images/order/order_scan.png"),
            }
        },
        methods:{
            scan(){
                try{
                    let _this = this;
                    u.native.scan(function (respon) {
                        if(respon){
                            let result = respon;
                            if(result){
                                if(String(result) == Number(result)){
                                    _this.$router.push({name:'orderDetail',query:{orderId: result,isScan:true}})
                                }else{
                                    // _this.$toast('请扫描待核销订单二维码');
                                    _this.$router.push({name:'scanBlank',query:{content: result}})
                                }
                            }
                        }
                    })

                }catch (e) {
                    this.$toast('请在App上操作');
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .card{
        margin: .7rem .36rem 0;
        padding-bottom: .4rem;
    }
    .input{
        text-align: center;
        width: 100%;
        font-size: .68rem;
        line-height: .95rem;
        color: #333;
        border: none;
        background: none;
        outline: none;
        padding: 0 .5rem;
        margin-top: .15rem;
        font-weight: 600;
        letter-spacing: .15rem;
    }
    .main-btn{
        margin: .7rem .36rem 0;
    }
    .scan-img{
        position: fixed;
        width: 2.1rem;
        height: 2.1rem;
        bottom: 1.1rem;
        left: 50%;
        margin-left: -1.05rem;
        z-index: 10;
    }
</style>



// WEBPACK FOOTER //
// verification.vue?0ff05c39